import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PaymentCancel = () => {
  return (
    <div className="bg-[#f2e5de] min-h-screen flex flex-col" data-testid="payment-cancel-page">
      <Navbar />
      <section className="feral-texture flex-1 flex items-center justify-center px-6 py-32">
        <div className="max-w-lg w-full bg-white border border-[#d9c3a8] rounded-lg shadow-xl p-8 md:p-10 text-center">
          <XCircle size={48} className="text-[#9a876f] mx-auto mb-6" />
          <h1 className="feral-serif text-[#9b3d0a] text-3xl mb-3">Payment cancelled</h1>
          <p className="text-[#6e5646] mb-6">
            No payment was taken. Your basket is still here whenever you're ready.
          </p>
          <Link
            to="/events"
            data-testid="cancel-back-to-events-button"
            className="inline-block bg-[#9b3d0a] hover:bg-[#7e3208] text-[#f2e5de] px-8 py-3 tracking-[0.12em] text-sm font-semibold transition-colors"
          >
            BACK TO EVENTS
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PaymentCancel;
